import {handleActions, createAction} from 'redux-actions';
import {
    axios,
    axiosWithoutHeaders
} from "../cores/axiosWrapper";
import config from '../config';

function getUploadUrlAPI (stageId, apiEndpoint, projectId, resource, fileName, isUnique) {
    const headers = {
        stageId
    };
    if(projectId) {
        headers.projectId = projectId;
    }
    return axios.get(`${apiEndpoint}/resources/upload-url`, {
        headers,
        params :
        {
            resource,
            fileName,
            isUnique
        }
    });
}

function getUploadUrlCopyAPI (stageId, apiEndpoint, projectId, target, key) {
    const headers = {
        stageId
    };
    if(projectId) {
        headers.projectId = projectId;
    }
    return axios.get(`${apiEndpoint}/resources/upload-url/copy`, {
        headers,
        params : { 
            target, 
            key
        }
    });
}

export const getUploadUrl = (resource, fileName, isUnique = true) => (dispatch, getState) => {
    const { 
        stage, 
        project 
    } = getState(); 
   
    return new Promise((resolve, reject) => {
        getUploadUrlAPI (stage.id, stage.endpoint, project.id, resource, fileName, isUnique)
            .then((response) => {
                resolve(response.data); 
            }).catch(error => {
                reject(error);
            })
            
    })
};

/**
 * Public S3 object accessURL 반환 및 복사
 * @author 이춘길
 * @param {string} target : target soruce key (복사 대상)
 * @param {string} key : prefix key
 * @returns accessURL
 */
export const getUploadUrlCopy = (target, key) => (dispatch, getState) => {
    const { 
        stage, 
        project 
    } = getState(); 
   
    return new Promise((resolve, reject) => {
        getUploadUrlCopyAPI (stage.id, stage.endpoint, project.id, target, key)
            .then((response) => {
                resolve(response.data); 
            }).catch(error => {
                reject(error);
            })
            
    })
};